import styled, { css } from 'styled-components';
import { COLOR } from '@src/styles/color';

const selectableBox = css`
  border: 0.5px solid
    ${({ isSelected }) => (isSelected ? COLOR.indigo[100] : COLOR.indigo[16])};
  border-radius: 12px;
`;

export const StyledStyleList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const StyledNoCaptionOption = styled.button`
  ${selectableBox}
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
  width: 100%;
  height: 48px;
  padding: 4px 12px;
  background: none;
  cursor: pointer;

  svg {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    color: ${COLOR.indigo[100]};
  }

  .no-caption-label {
    flex-shrink: 0;
    white-space: nowrap;
    color: ${COLOR.descriptionGray};
  }
`;

export const StyledStyleCard = styled.div`
  ${selectableBox}
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
  width: 100%;
  padding: 4px;
  cursor: pointer;

  .style-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 100%;
    height: 80px;
    /* Lề chứ không phải trần, để panel kéo rộng thì chữ có thêm chỗ. */
    padding: 0 40px;
    border-radius: 8px;
    background-color: ${COLOR.indigo[16]};
  }

  .style-sample {
    position: relative;
    z-index: 0;
    color: ${COLOR.black.default};
    text-align: center;
    word-break: break-word;
  }

  .style-sample::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -1;
    background-color: var(--sample-bg, transparent);
    border-radius: var(--sample-bg-radius, 0);
    filter: blur(var(--sample-bg-blur, 0px));
  }

  /* Figma ghi gap 130px nhưng hàng bị tràn; thẻ khác dùng space-between. */
  .style-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    gap: 8px;
    width: 100%;
    height: 32px;
    padding: 0 8px;
  }

  .style-name {
    flex: 1 0 0;
    min-width: 0;
    /* body-14-medium đặt width: max-content, phải bỏ để co theo flex. */
    width: auto;
    color: ${COLOR.black.default};
    /* Tên dài thì cắt, đừng xuống dòng trong hàng cao 32px. */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .style-config-button {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    padding: 8px;
    border: none;
    border-radius: 480px;
    background: none;
    cursor: pointer;

    &:hover {
      background-color: ${COLOR.indigo[8]};
    }

    svg {
      width: 20px;
      height: 20px;
      color: ${COLOR.indigo[100]};
    }
  }
`;
